import { normalizeStringForComparison } from "@lib/helpers";

const getFilterKeyByActive = (activeInput) => {
  switch (activeInput) {
    case "region":
      return "county";
    case "city":
      return "locality";
    case "search":
      return "name";
    default:
      return "";
  }
};

const getAvailableMarkers = ({ data, activeInput, filter }) => {
  if (!data?.length || !activeInput || !filter) return [];

  const normalizedFilter = normalizeStringForComparison(filter);
  const filterKey = getFilterKeyByActive(activeInput);

  return data.filter((item) => {
    if (activeInput === "search") {
      return item.name.toLowerCase().includes(normalizedFilter);
    } else {
      const value = item.address?.[filterKey];
      return normalizeStringForComparison(value) === normalizedFilter;
    }
  });
};

export default getAvailableMarkers;
